module.exports = __webpack_public_path__ + "static/media/luz.e5f1eb6e.jpg";